import Prescription from './Prescription'
export default Prescription
